module.exports = __webpack_public_path__ + "static/userexperience-31cb5d459c15ad68127f8f9481f98fa1.svg";